<template>
  <AppLayout v-bind:versions="versions">
    <router-view/>
  </AppLayout>
</template>
<script>
import EventBus from "./common/EventBus";

export default {
  data: function () {
    return {
      versions: {
        local: "2.0.18",
        remote: "2.0.18"
      }
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/auth/login');
    }
  },
  mounted() {
    EventBus.on("logout", () => {
      this.logOut();
    });
  },
  beforeUnmount() {
    EventBus.remove("logout");
  }
};
</script>
